import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CategoryData } from '../category.model';
import { CategoryService } from 'src/app/services/category.service';
@Component({
  selector: 'app-category-edit-popup',
  templateUrl: './category-edit-popup.component.html',
  styleUrls: ['./category-edit-popup.component.css']
})
export class CategoryEditPopupComponent {

  categoryForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    public dialogRef: MatDialogRef<CategoryEditPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CategoryData
  ) {
    // shelf/maxLife are optional: most categories never had them, and a
    // required validator would block saving any of those. maxLife (days) is
    // what the driver app's svinn suggestions read as the category's shelf
    // life — a product-level shelfLifeDays overrides it.
    this.categoryForm = this.fb.group({
      name: ['', Validators.required],
      shelf: [''],
      maxLife: ['', Validators.min(1)],
      active: [true]
    });
    if (data?.dbid) {
      this.categoryService.getCategoryById(data.dbid).subscribe(category => {
        if (category) {
          this.categoryForm.patchValue({
            name: category['name'] ?? '',
            shelf: category['shelf'] ?? '',
            maxLife: category['maxLife'] ?? '',
            active: category['svinnStatus'] ?? true
          });
        }
      });
    }
  }
  onSubmit(): void {
if (this.categoryForm.valid) {
      const formData: CategoryData = {
        ...this.categoryForm.value,
        dbid: this.data.dbid
      };
      this.dialogRef.close(formData);
    }else {
      console.log("Form is invalid", this.categoryForm.errors);
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}

